import React from 'react';
import {BaseMixin, ElementaryMixin, Tools} from './../common/common.js';

import InputMixin from './mixins/input-mixin.js'
import GroupMixin from './mixins/group-mixin.js'
import Checkbox from './checkbox.js';

import './checkboxes.less';

export const Checkboxes = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    InputMixin,
    GroupMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Forms.Checkboxes',
    classNames: {
      main: 'uu5-forms-checkboxes',
      inline: 'uu5-forms-inputs-inline',
    },
    defaults: {
      onGlyphicon: 'uu-glyphicon-ok'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  componentWillMount(){
    let value = this._getInitialValue();

    if (this.props.onValidate && typeof this.props.onValidate === 'function') {
      this._validateOnChange({value: value, event: null, component: this})
    } else {
      this.setState({value: value});
    }

    return this;
  },

  componentWillReceiveProps(nextProps) {
    if (this.props.controlled) {
      if (nextProps.value !== undefined) {
        let newState = this.state.value;
        nextProps.value.forEach(function (value) {
          newState[value.name] = value.value;
        });

        if (this.props.onValidate && typeof this.props.onValidate === 'function') {
          this._validateOnChange({value: newState, event: null, component: this})
        } else {
          this.setState({value: newState});
        }
      }
    }
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  reset_(setStateCallback){
    let value = this._getInitialValue();
    this.setState({
      message: this.props.message,
      feedback: this.props.feedback,
      value: value,
      readOnly: this.props.readOnly
    }, setStateCallback);
  },

  getValue_(){
    return this._getValueArray();
  },

  setValue_(value, setStateCallback){
    let newValue = value;
    console.log(`set value ${value}`)

    this.setState({value: newValue}, setStateCallback);

    return this;
  },
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getInitialValue(props) {
    props = props || this.props;
    var value = {};

    props.value.forEach(function (checkbox, i) {
      value[checkbox.name || i.toString()] = checkbox.value || false;
    });

    return value;
  },

  _onChange (opt) {
    opt.value = !opt.value;

    if (!this.isDisabled() && !this.isReadOnly()) {
      if (typeof this.props.onChange === 'function') {
        var result = this._checkRequired(opt);

        result.value = this._getValueArray(result.value);

        if (result && typeof result === 'object' && result.feedback === 'error') {
          result.value = this.getValue_(result.value);
          this.setError(result.message, result.value);
        } else if (typeof this.props.onValidate === 'function') {
          result = this.props.onValidate(result);
        } else {
          result = this.props.onChange(result);
        }

        if (result && typeof result === 'object') {
          if (typeof this.props.onChangeFeedback === 'function') {
            this.props.onChangeFeedback({
              feedback: result.feedback,
              message: result.message,
              value: result.value,
              callback: result.setStateCallback,
              component: this
            });
          } else {
            result.value = this._getValue(result.value);
            this.setFeedback(result.feedback, result.message, result.value);
          }
        } else {
          //TODO: not accessible - verify!!!!
          this._setValue(opt);
        }
      } else {
        this._setValue(opt);
      }
    }

    return this;
  },

  _validateOnChange(opt){
    opt.value && (opt.value = this._getValueArray(opt.value));
    let result = typeof this.props.onValidate === 'function' ? this.props.onValidate(opt) : null;

    if (result) {
      if (typeof result === 'object') {
        if (result.feedback) {
          result.value = this._getValue(result.value);
          this.setFeedback(result.feedback, result.message, result.value);
        } else {
          //TODO: verify opt.value - must be object
          this.setState({value: opt.value});
        }
      } else {
        this.showError('validateError', null, {context: {event: e, func: this.props.onValidate, result: result}});
      }
    }

    return this;
  },

  _getValueArray(value){
    let newValue = [];
    value = value || this.state.value;
    value && Object.keys(value).forEach((key) => {
      for(let i = 0; i < this.props.value.length; i++) {
        let item = Tools.merge({}, this.props.value[i]);
        if(item.name === key) {
          item.value = value[key];
          newValue.push(item);
        }
      }
    });
    return newValue;
  },



  _getValue(value){
    let newValue = {};

    value && value.forEach((checkbox) => {
      newValue[checkbox.name] = checkbox.value || false;
    });

    return newValue;
  },

  _setValue(opt){
    var result = this._checkRequired(opt);

    if (result && typeof result === 'object' && result.feedback === 'error') {
      this.setError(result.message, result.value);
    } else if (typeof this.props.onValidate === 'function') {
      result.value = this._getValueArray(result.value);
      result = this.props.onValidate(result);
      result.value = this._getValue(result.value);
      this.setFeedback(result.feedback, result.message, result.value);
    } else {
      this.setInitial('', result.value);
    }

    return this;
  },

  _checkRequired(opt) {
    let newState = this._getNewState(opt);

    opt.value = newState;

    if (this.props.required) {
      if (this._isSelected(newState)) {
        if (typeof this.props.onChange !== 'function') {
          opt = {feedback: 'success', message: '', value: newState};
        }
      } else {
        opt = {feedback: 'error', message: this.props.requiredMessage, value: newState};
      }
    }
    return opt;
  },

  _getNewState(opt) {
    let newState = Tools.merge({}, this.state.value);

    Object.keys(this.state.value).forEach((key) => {
      let value = this.state.value[key];
      if (key === opt.component.getName()) {
        value = !opt.value;
      }
      newState[key] = value;
    });

    return newState;
  },

  _isSelected(newState) {
    var value = newState ? Tools.merge({}, this.state.value, newState) : this.state.value;

    return Object.keys(value).map((name) => {
        return value[name];
      }).indexOf(true) > -1;
  },


  _getCheckboxes(){
    return this.props.value.map((box, key) => {
      let checkboxProps = Tools.merge({}, box);
      let disabled = this.props.disabled ? true : box.disabled ? true : false;

      return <Checkbox
        key={key}
        value={this.state.value && this.state.value[checkboxProps.name]}
        label={box.label}
        onChange={this._onChange}
        name={box.name}
        labelPosition={this.props.labelPosition}
        disabled={disabled}
        onGlyphicon={box.onGlyphicon || this.props.onGlyphicon || this.getDefault().onGlyphicon}
        offGlyphicon={box.offGlyphicon || this.props.offGlyphicon}

      />
    });
  },

  _getMainAttrs(){
    let attrs = this._getInputAttrs();

    if (this.props.inline) {
      attrs.className += ' ' + this.getClassName().inline;
    }

    return attrs;
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render () {
    let inputId = this.getId() + '-input';
    return (
      <div {...this._getMainAttrs()}>
        {this.getLabel(inputId)}
        {this.getInputWrapper([this._getCheckboxes()])}
      </div>
    );
  }
  //@@viewOn:render
});

export default Checkboxes;



// WEBPACK FOOTER //
// ./forms/checkboxes.js